import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaHeartPulse, FaUtensils, FaBriefcaseMedical, FaCircleNodes, FaWifi, FaVideo, FaFileWaveform, FaUserGroup, FaHouseLaptop } from "react-icons/fa6";

import { useForm, useFormValidation } from "../../hooks"
import { startLogin } from "../../redux/slices/auth";

import { HomeButton, MembresiaInput, PasswordInput, PrimaryButton } from "../../components";

import styles from './Login.module.css';

export const Login = () => {

  const loginSectionRef = useRef(null);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { status } = useSelector(state => state.auth);

  const { membresia, password, onInputChange } = useForm({ membresia: '', password: '' });

  const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation } = useFormValidation([{field: 'membresia', default: false}, {field: 'password', default: false}]);

  const scrollToLogin = () => {
    loginSectionRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const onSubmit = async ( event ) => {
    event.preventDefault();
    
    startFormValidation();
    
    if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
      await dispatch(startLogin(membresia, password));
    }

  }

  useEffect(() => {
    navigate("", { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="row mt-5 mb-5">
        <div className="col"></div>
      </div>
      <div className={"row " + styles.seccion}>
        <div className={"col-md-12 col-lg-6 col-xxl-6 " + styles.homeHeadingContainer}>
          <div className={styles.heroBadge}>Consulta médica en línea</div>
          <div className={styles.homeHeading}>Controla tu diabetes de manera Virtual</div>
          <div className={styles.homeHeadingText}>¡Olvidate de la sala de espera! Clínicas del Azúcar te conecta de inmediato con médicos especialistas a través de videollamada y chat.</div>
          <HomeButton
            text="Ingresar"
            type="button"
            onClick={scrollToLogin}
          />
        </div>
        <div className="col-md-12 col-lg-6 col-xxl-6">
          <div className={styles.medicoImage}></div>
        </div>
      </div>
      <div className="row mb-5 gy-3">
        <div className="col-sm-12 col-md">
          <div className={styles.infoCard}>
            <div className={styles.infoCardIcon}>
              <FaBriefcaseMedical />
            </div>
            <div className={styles.infoSubheader}>Especialista</div>
            <div className={styles.infoText}>Consulta con médicos expertos para un diagnóstico y tratamiento personalizados desde casa.</div>
          </div>
        </div>

        <div className="col-sm-12 col-md">
          <div className={styles.infoCard}>
            <div className={styles.infoCardIcon}>
              <FaUtensils  />
            </div>
            <div className={styles.infoSubheader}>Nutrición</div>
            <div className={styles.infoText}>Recibe asesoría de nutriólogos para llevar una dieta saludable y controlar tu diabetes.</div>
          </div>
        </div>

        <div className="col-sm-12 col-md">
          <div className={styles.infoCard}>
            <div className={styles.infoCardIcon}>
              <FaHeartPulse  />
            </div>
            <div className={styles.infoSubheader}>Control Vital</div>
            <div className={styles.infoText}>Monitorea indicadores clave como glucosa y presión con apoyo profesional.</div>
          </div>
        </div>

        <div className="col-sm-12 col-md">
          <div className={styles.infoCard}>
            <div className={styles.infoCardIcon}>
              <FaCircleNodes  />
            </div>
            <div className={styles.infoSubheader}>Psicología</div>
            <div className={styles.infoText}>Mejora tu bienestar emocional con la ayuda de psicólogos especializados.</div>
          </div>
        </div>
      </div>
      <div id="login-section" className={styles.formContainer + " row"} ref={loginSectionRef}>
        <div className="offset-lg-0 col-lg-12 offset-xxl-1 col-xxl-10">
          <div className={styles.loginContainer}>
            <div className="row">
              <div className="col-12">
                <div className={styles.formHeader}>Video Consulta</div>
              </div>
              <div className="col-12">
                <div className={styles.loginSubtitle}>
                  Acceso exclusivo para pacientes activos
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-xxl-6">
                <div className="row">
                  <div className="col">
                    <div className={styles.loginFormCard}>
                      <form onSubmit={ onSubmit }>
                        <div className="row">
                          <div className="col">
                            <MembresiaInput
                              formFieldStatus={ formFields['membresia'].status }
                              label="Membresia"
                              name="membresia"
                              onChange={ onInputChange }
                              placeholder="Membresia"
                              required={true}
                              requiredIndicator={false}
                              setFormFieldValidation={ setFormFieldValidation }
                              value={ membresia }
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <PasswordInput
                              formFieldStatus={ formFields['password'].status }
                              label="Contraseña"
                              name="password"
                              onChange={ onInputChange }
                              placeholder="Contraseña"
                              required={true}
                              requiredIndicator={false}
                              setFormFieldValidation={ setFormFieldValidation }
                              value={ password }
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <PrimaryButton
                              block={true}
                              disabled={status === 'checking' || formValidationStatus === 'checking'}
                              text="Ingresar"
                              type="submit"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xxl-6">
                <div className="row">
                  <div className="col">
                    <div className={styles.cardSubHeader}>Tips y recomendaciones</div>
                    <div></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className={styles.tipItem}>
                      <div className={styles.cardIconContainer}>
                        <FaWifi className={styles.infoIcon} />
                      </div>
                      <div className={styles.tipContent}>
                        <div className={styles.infoSubheader}>Conexión estable</div>
                        <div className={styles.infoText}>Asegúrate de tener un buen internet.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className={styles.tipItem}>
                      <div className={styles.cardIconContainer}>
                        <FaVideo className={styles.infoIcon} />
                      </div>
                      <div className={styles.tipContent}>
                        <div className={styles.infoSubheader}>Cámara y micrófono</div>
                        <div className={styles.infoText}>Actívalos para que el especialista pueda verte y escucharte.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className={styles.tipItem}>
                      <div className={styles.cardIconContainer}>
                        <FaFileWaveform className={styles.infoIcon} />
                      </div>
                      <div className={styles.tipContent}>
                        <div className={styles.infoSubheader}>Documentos listos</div>
                        <div className={styles.infoText}>Ten a la mano tus resultados y medicamentos.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className={styles.tipItem}>
                      <div className={styles.cardIconContainer}>
                        <FaHouseLaptop className={styles.infoIcon} />
                      </div>
                      <div className={styles.tipContent}>
                        <div className={styles.infoSubheader}>Espacio privado</div>
                        <div className={styles.infoText}>Busca un lugar sin ruidos ni distracciones.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className={styles.tipItem}>
                      <div className={styles.cardIconContainer}>
                        <FaUserGroup className={styles.infoIcon} />
                      </div>
                      <div className={styles.tipContent}>
                        <div className={styles.infoSubheader}>Acompañante opcional</div>
                        <div className={styles.infoText}>Un familiar puede apoyarte si lo prefieres.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
